module.exports = __webpack_public_path__ + "img/wanjuleqi.356c4dbf.png";